import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    margin: {
      width: "100%",
      height: "83px",
      marginTop: "1.8rem",
      backgroundColor: "#FFFFFF",
      borderRadius: "2px",
      display: "flex",
      alignItems: "center",
      justifyItems: "center",
    },
    align: {
      width: "100%",
      height: "83px",
      marginTop: "1.8rem",
      backgroundColor: "#FFFFFF",
      borderRadius: "2px",
      display: "flex",
      flexDirection: "column",
      
    },
    parag: {
      color: "#808080",
      marginLeft: "20px",
      marginTop: "10px",
    },
   
    
  })
);

export default useStyles;